import moment from "moment";
import PropTypes from 'prop-types';
import { toast } from "../../../core/helpers/message-helper";
import { createContext, useState, useEffect } from "react";
import { obtenerCuadroTurnos } from "../services/nomina-cuadro-turnos";

const CuadroTurnosContext = createContext({});

export function CuadroTurnosProvider({ children }) {
    const [isLoading, setIsLoading] = useState(true);
    const [allDataCuadroTurnos, setAllDataCuadroTurnos] = useState([]);
    const [dataCuadroTurnos, setDataCuadroTurnos] = useState({
        area: "",
        festivos: {},
        empleados: [],
        cuadroTurnos: [],
        fechasCuadroTurnos: [],
    });

    const [filtros, setFiltros] = useState({
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(1, "month").format("YYYY-MM-DD"),
        sedeAreaLider: null,
        subAreasLider: null,
        turnos: null,
    });

    async function getCuadroTurnos() {
        setIsLoading(true);

        const resp = await obtenerCuadroTurnos(filtros);
        if (!resp.status) return toast.error(resp.message);

        const cuadroTurnosData = {
            area: resp.data.area,
            cuadroTurnos: resp.data.cuadroTurnos,
            fechasCuadroTurnos: resp.data.fechasCuadroTurnos,
            festivos: Array.isArray(resp.data.festivos)
                ? {}
                : resp.data.festivos,
        };

        setAllDataCuadroTurnos(cuadroTurnosData.cuadroTurnos);
        setDataCuadroTurnos(cuadroTurnosData);
        setIsLoading(false);
    }

    useEffect(() => getCuadroTurnos(), []);

    return (
        <CuadroTurnosContext.Provider
            value={{
                isLoading,
                getCuadroTurnos,
                dataCuadroTurnos,
                allDataCuadroTurnos,
                setDataCuadroTurnos,
                filtros,
                setFiltros,
            }}
        >
            {children}
        </CuadroTurnosContext.Provider>
    );
}

CuadroTurnosProvider.propTypes = {
    children: PropTypes.element
}

export default CuadroTurnosContext;
